import Vue from 'vue';
import Router from 'vue-router';
import store from '@/core/services/store';
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc';
import Callback from '@/view/Callback';
import Swal from 'sweetalert2';
import { RepoFactory } from '@/baseRepository/Factory';
const authRepository = () => RepoFactory.get('auth');
const settingRepository = () => RepoFactory.get("setting");
const walletTransactionsRepository = () =>
  RepoFactory.get('walletTransactions');
Vue.use(Router);
/**
 *  extract route files inside modules folder
 */
const requireRoute = require.context('@/modules/', true, /routes\/index.js/);
const requireLayouts = require.context('@/view/layout/', false, /.*.vue/);

const routes = [];
const routerFiles = [];
const moduleRoutes = [];
const layoutRoutes = [];
const defaultLayout = 'Layout';
requireRoute.keys().forEach((fileName) => {
  routerFiles.push(requireRoute(fileName).default);
});

routerFiles.forEach((el) => {
  moduleRoutes.push(...el);
});

function makeName(fileName) {
  let name = fileName.split('/')[1].split('.')[0];
  return name[0].toUpperCase() + name.slice(1);
}

requireLayouts.keys().forEach((fileName) => {
  const layoutName = makeName(fileName);
  layoutRoutes[layoutName] = {
    path: '',
    component: () => import(`@/view/layout/${layoutName}`),
    children: [],
  };
  if (layoutName === defaultLayout) {
    layoutRoutes[layoutName]['children'].push({
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('@/view/pages/Dashboard.vue'),
    });
  }
});

moduleRoutes.forEach((modul) => {
  if (modul.meta?.layout) {
    layoutRoutes[modul.meta.layout]['children'].push(modul);
  } else {
    layoutRoutes[defaultLayout]['children'].push(modul);
  }
});

for (const key in layoutRoutes) {
  routes.push(layoutRoutes[key]);
}

let router = new Router({
  mode: 'history',
  routes: [
    {
      name: '',
      path: '/Callback',
      component: Callback,
    },
    ...routes,
    {
      path: '*',
      redirect: '/404',
    },
    {
      // the 404 route, when none of the above matches
      path: '/404',
      name: '404',
      component: () => import('@/view/pages/error/Error-1.vue'),
    },
  ],
});
 
 
router.beforeEach(vuexOidcCreateRouterMiddleware(store, 'oidc'));
router.beforeEach((to, from, next) => {
  next();
  let hasAvailabileTime = store.getters.availabileTime > 0 ? true : false;
  //TODO the next line code is temprory for Notification open link
  if (store.getters.membershipPlan == null) hasAvailabileTime = true;
 // console.log('store.getters.availabileTime' + store.getters.availabileTime);
  if (!hasAvailabileTime ) {
    if (
      // to.path.startsWith('/trade-response') ||
      to.path.startsWith('/supplier-products') ||
      to.path.startsWith('/contents')
    ) {
      next({
        path: '/dashboard',
      });
      return Swal.fire({
        icon: 'info',
        title: 'پایان دوره آزمایشی',
        html: '<h4>     صنعتگر محترم،     </h4> </br>     دسترسی و بهره‌مندی از این بخش نیازمند فعال سازی <strong>؛خدمات پایه؛</strong> است. لطفاً نسبت به خرید حداقل حق اشتراک پایه    .یا <a href="/financial-management/subscription">هر اشتراک مورد نیاز</a> دیگری اقدام فرمایید.</br> <a href="/financial-management/subscription">لینک خرید اشتراک- منوی مدیریت مالی</a>',
        confirmButtonText: ' بستن',
      });
    }
  }

  if (!store.getters.authBaseUrl) {
    fetch(window.location.origin + '/config.json')
      .then((response) => response.json())
      .then((data) => {
        store.commit('SET_CONFIG', data);
      });
  }
  setTimeout(() => {
        let userPhone = null;
    let visitorPhones = [];
    //Check Taksaan visitors phone if it is then set     store.commit('setAuthorize', 'supplier');
        //----------------------
    settingRepository()
        .getSettings(
          store.getters.settingBaseUrl,
          { clientId: "TaksaanVisitorsInSupplier" },
          {}
        )
        .then((res) => {
            res.data.visitorsData.forEach((el) => {
              visitorPhones.push(el.PhoneNumber);
            });
          store.commit('setVisitorsPhoneList',visitorPhones)
         // console.log("visitorPhones from store", store.getters.visitorsPhoneList)
        })
        .catch((error) => {
          console.log("error On getting visitors phone",error)
        })
        .finally( );


    //-----------------
    authRepository()
      .getUserDetail(store.getters.authBaseUrl)
      .then((res) => {
        if (res.data.roles) {
          let rols = res.data.roles;
          //----------
           userPhone = res.data.phone;
          store.commit('setCurrentUserIsVisitor',false)
         // let currentUserIsVisitor = false;
          let findedePhone = visitorPhones.find( (f)  => f == userPhone);
          //console.log("findedePhone is", findedePhone)
          //console.log("userPhone is",userPhone)
          if (findedePhone === userPhone) {
            //currentUserIsVisitor = true;
           
            store.commit('setCurrentUserIsVisitor', true)
            // store.commit('setAuthorize', 'registration');
            //console.log("setAuthorize for visitoe is ",store.getters.authorize)
          }
          //----------------------------


          store.commit('setUserDetails', res.data);
          if (store.getters.currentUserIsVisitor) {
             if (to.path == '/business-registration')
                return next({
                  path: '/business-registration',
                });

          }

          if (rols && rols.length == 0) {
            store.commit('setAuthorize', 'registration');
            // if (
            //   to.path !== '/business-registration' ||
            //   to.path !== '/consumer-registration'
            // ) {
              // if (to.path == '/consumer-registration')
              //   return next({
              //     path: '/consumer-registration',
              //   });

              return next({
                path: '/business-registration',
                // path: '/business-registration',
              });
            //}
          }
          if (
            rols &&
            (rols.includes('merchant') || rols.includes('consumer')) &&
            !rols.includes('supplier') &&
            !rols.includes('admin')
          ) {
            store.commit('setAuthorize', 'merchant');
            if (to.meta.roles && to.meta.roles.includes('merchant')) {
              return next();
            } else {
              return next({
             //   path: '/business-information',
              });
            }
          }

          if (rols && rols.includes('supplier')) {
            store.commit('setAuthorize', 'supplier');
            if (to.meta.roles.includes('supplier')) {
              return next();
            } else {
              return next({
                path: '/dashboard',
              });
            }
          }
        }
      })
      .catch(() => {
        store.commit('setAuthorize', 'supplier');
        return next();
      });
      
      walletTransactionsRepository()
        .getWalletTransactionsCredit(store.getters.walletBaseUrl)
        .then((res) => {
          store.commit( 'setUserWalletCredit',res.data.totalCredit.amount);

        })
        .catch(( ) => {
           
        });
     
  }, 300);

  return router;
});

export default router;
